export const useStorageReady = () => {
  // Check if the storage is ready via nuxtApp
  if (import.meta.client) {
    try {
      if (window.localStorage) {
        return true
      }
      return false
    } catch {
      return false
    }
  } else {
    return false
  }
}
